import settings from 'settings'

function DataProviderIcon({ provider }: { provider: string }) {
  const url = `${settings.spatialDataCatalogAssetstUrl}/providers/${provider}.png`
  return <img height="24px" width="24px" src={url} />
}

export default DataProviderIcon
